import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AssignmentsPage } from '@/features/security/assignments-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Segment statique : gagne sur `/$tenant/roles/$roleId` (rang du routeur), aucun rôle ne s'appelle « assignments ». */
export const Route = createFileRoute('/$tenant/roles/assignments')({ component: AssignmentsRoute });

function AssignmentsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="roles"
      crumbs={[{ label: t('security.roles.title') }, { label: t('security.assignments.title') }]}
    >
      <AssignmentsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
